import { SettingsSectionPage } from "./Section/SettingsSectionPage";
import { SettingsAccountPage } from "./Account/SettingsAccountPage";
import { SettingsPropertiesPage } from "./Properties/SettingsPropertiesPage";
import { SettingsAutopaySubscriptionPage } from "./AutopaySubscription/SettingsAutopaySubscriptionPage";
import { SettingsProtestHistoryPage } from "./ProtestHistory/SettingsProtestHistoryPage";
import { SettingsHistoricalAchievementsPage } from "./HistoricalAchievements/SettingsHistoricalAchievementsPage";
import { SettingsAppSettingsPage } from "./AppSettings/SettingsAppSettingsPage";
import { SettingsContactUsPage } from "./ContactUs/SettingsContactUsPage";
import { SettingsContactUsChatPage } from "./ContactUsChat/SettingsContactUsChatPage";
import { SettingsLogoutPage } from "./Logout/SettingsLogoutPage";

export { SettingsAccountPage };
export { SettingsPropertiesPage };
export { SettingsAutopaySubscriptionPage };
export { SettingsProtestHistoryPage };
export { SettingsHistoricalAchievementsPage };
export { SettingsAppSettingsPage };
export { SettingsContactUsPage };
export { SettingsContactUsChatPage };
export { SettingsLogoutPage };

export const SettingsHomePage = () => (
  <SettingsSectionPage
    title="Home"
    description="Configure your home dashboard behavior and quick links."
  />
);

// Dedicated screen exported above.
